var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-2 0 24 20",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface2673542"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(29.803922%,68.627451%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 19.207031 2.417969 L 10.542969 2.417969 L 10.542969 17.582031 L 19.207031 17.582031 C 19.507812 17.582031 19.75 17.339844 19.75 17.042969 L 19.75 2.957031 C 19.75 2.660156 19.507812 2.417969 19.207031 2.417969 Z M 19.207031 2.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 14.332031 5.125 L 18.125 5.125 L 18.125 6.75 L 14.332031 6.75 Z M 14.332031 10.542969 L 18.125 10.542969 L 18.125 12.167969 L 14.332031 12.167969 Z M 14.332031 13.25 L 18.125 13.25 L 18.125 14.875 L 14.332031 14.875 Z M 14.332031 7.832031 L 18.125 7.832031 L 18.125 9.457031 L 14.332031 9.457031 Z M 10.542969 5.125 L 13.25 5.125 L 13.25 6.75 L 10.542969 6.75 Z M 10.542969 10.542969 L 13.25 10.542969 L 13.25 12.167969 L 10.542969 12.167969 Z M 10.542969 13.25 L 13.25 13.25 L 13.25 14.875 L 10.542969 14.875 Z M 10.542969 7.832031 L 13.25 7.832031 L 13.25 9.457031 L 10.542969 9.457031 Z M 10.542969 7.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.039216%,49.019608%,19.607843%)",
      fillOpacity: 1
    },
    d: "M 11.625 19.75 L 0.25 17.582031 L 0.25 2.417969 L 11.625 0.25 Z M 11.625 19.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 7.363281 13.792969 L 6.054688 11.320312 C 6.003906 11.226562 5.953125 11.058594 5.902344 10.8125 L 5.882812 10.8125 C 5.855469 10.929688 5.796875 11.105469 5.707031 11.34375 L 4.394531 13.792969 L 2.359375 13.792969 L 4.777344 10 L 2.566406 6.207031 L 4.644531 6.207031 L 5.726562 8.480469 C 5.8125 8.660156 5.886719 8.875 5.953125 9.121094 L 5.976562 9.121094 C 6.019531 8.972656 6.097656 8.75 6.214844 8.457031 L 7.421875 6.207031 L 9.324219 6.207031 L 7.050781 9.96875 L 9.386719 13.789062 L 7.363281 13.789062 Z M 7.363281 13.792969 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.e91434b7.svg";
export { ForwardRef as ReactComponent };